var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeVoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 64,
    viewBox: "0 0 47 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67656 33.1066C7.96789 33.1066 9.01472 34.1534 9.01472 35.4448C9.01472 43.426 15.4843 49.8962 23.4694 49.8962C31.4509 49.8962 37.9208 43.4263 37.9208 35.4448C37.9208 34.1534 38.9676 33.1066 40.259 33.1066C41.5503 33.1066 42.5971 34.1534 42.5971 35.4448C42.5971 46.009 34.0336 54.5725 23.4694 54.5725C12.9023 54.5725 4.33839 46.0092 4.33839 35.4448C4.33839 34.1534 5.38522 33.1066 6.67656 33.1066Z",
    fill: "#5627D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33764 19.1279C4.33764 8.56331 12.9015 0 23.4685 0C34.0329 0 42.5965 8.56356 42.5965 19.1279V25.8034C42.5965 27.0947 41.5497 28.1416 40.2584 28.1416C38.967 28.1416 37.9202 27.0947 37.9202 25.8034V19.1279C37.9202 11.1463 31.4503 4.67633 23.4685 4.67633C15.4836 4.67633 9.01397 11.1465 9.01397 19.1279V25.8034C9.01397 27.0947 7.96714 28.1416 6.67581 28.1416C5.38447 28.1416 4.33764 27.0947 4.33764 25.8034V19.1279Z",
    fill: "#5627D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4998 49.8978C24.7912 49.8978 25.838 50.9446 25.838 52.2359V58.6094C25.838 59.9008 24.7912 60.9476 23.4998 60.9476C22.2085 60.9476 21.1617 59.9008 21.1617 58.6094V52.2359C21.1617 50.9446 22.2085 49.8978 23.4998 49.8978Z",
    fill: "#5627D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35.4451C0 34.1537 1.04683 33.1069 2.33817 33.1069H44.5983C45.8896 33.1069 46.9365 34.1537 46.9365 35.4451C46.9365 36.7364 45.8896 37.7832 44.5983 37.7832H2.33817C1.04683 37.7832 0 36.7364 0 35.4451Z",
    fill: "#5627D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4776 24.9059C16.4776 23.6145 17.5245 22.5677 18.8158 22.5677H28.1214C29.4127 22.5677 30.4596 23.6145 30.4596 24.9059C30.4596 26.1972 29.4127 27.244 28.1214 27.244H18.8158C17.5245 27.244 16.4776 26.1972 16.4776 24.9059Z",
    fill: "#5627D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5499 61.6618C15.5499 60.3705 16.7368 59.3237 18.2009 59.3237H28.7516C30.2158 59.3237 31.4027 60.3705 31.4027 61.6618C31.4027 62.9532 30.2158 64 28.7516 64H18.2009C16.7368 64 15.5499 62.9532 15.5499 61.6618Z",
    fill: "#5627D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5653 16.271C19.5653 14.9796 20.6121 13.9328 21.9034 13.9328H25.031C26.3223 13.9328 27.3691 14.9796 27.3691 16.271C27.3691 17.5623 26.3223 18.6091 25.031 18.6091H21.9034C20.6121 18.6091 19.5653 17.5623 19.5653 16.271Z",
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVoice);
export default __webpack_public_path__ + "static/media/home-voice.5091c7f31d8c3bdfc2491941698599a6.svg";
export { ForwardRef as ReactComponent };